/* libs/oyan-ui/src/lib/features/admin/components/user-profile-preferences/user-profile-preferences.component.scss */
.user-profile-info-container {
  font-size: 12px;
}
.user-profile-info-section-title {
  font-size: 18px;
  font-weight: 600;
  white-space: nowrap;
  padding-bottom: 20px;
}
/*# sourceMappingURL=user-profile-preferences.component.css.map */
